import * as React from "react"

export default function ErrorWarningSquare(props) {
  return (
    <svg
      width={56}
      height={56}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={56} height={56} rx={8} fill="#EFEFEF" />
      <path
        d="M28 38c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10zm-1-7v2h2v-2h-2zm0-8v6h2v-6h-2z"
        fill={props.fill}
      />
    </svg>
  )
}